import { render } from "./SponsoredStudents.vue?vue&type=template&id=54c04e2e&scoped=true"
import script from "./SponsoredStudents.vue?vue&type=script&lang=js"
export * from "./SponsoredStudents.vue?vue&type=script&lang=js"

import "./SponsoredStudents.vue?vue&type=style&index=0&id=54c04e2e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c04e2e"]])

export default __exports__